import { inject, Injectable, signal } from '@angular/core';
import { StateCountry } from '../models/state-country.models';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class StateCountryService {
  private readonly http = inject(HttpClient);

  readonly states = signal<StateCountry[]>([]);

  load(): void {
    if (this.states().length) {
      return;
    }
    this.http
      .get<StateCountry[]>(`${environment.apiUrl}/api/analytics/v2/dictionary/state-country`)
      .subscribe((states) => this.states.set(states));
  }

  findById(id: string): StateCountry | undefined {
    return this.states().find((state) => state.id === id);
  }
}
